const GLOW_IMG = "/assets/images/onboarding-v5/onboarding-bg-glow.svg";

/** Solid dark backdrop with a centered purple glow ("Onboarding BG" in Figma). */
export const OnboardingDarkBackground = () => (
  <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden bg-[#130c2d]">
    <img
      src={GLOW_IMG}
      alt=""
      className="absolute top-1/2 left-1/2 w-[505px] max-w-none -translate-x-1/2 -translate-y-1/2"
    />
  </div>
);
